
import AppException from './AppException'
const YoutubeLinkParser = {
  parse: function (str) {
    var id = str
    if (str.startsWith('https://')) {
      try {
        let url = new URL(str)
        let searchParams = new URLSearchParams(url.search)
        if (url.hostname === 'www.youtube.com' || url.hostname === 'youtube.com') {
          // 電腦版網頁
          if (url.pathname === '/watch' && searchParams.has('v')) {
            id = searchParams.get('v')
            return id
          }
          // 嵌入網址
          if (url.pathname.startsWith('/embed')) {
            id = url.pathname.substring(7)
            return id
          }
          // 短影片 2023/05
          if (url.pathname.startsWith('/shorts')) {
            id = url.pathname.substring(8)
            return id
          }
        }
        // 短網址
        if (url.hostname === 'youtu.be') {
          id = url.pathname.substring(1)
          return id
        }
        // 手機版網址
        if (url.hostname === 'm.youtube.com') {
          if (url.pathname === '/watch' && searchParams.has('v')) {
            id = searchParams.get('v')
            return id
          }
        }
      } catch (e) {}
    }

    return id
  },
  testSelf: function () {
    if (YoutubeLinkParser.parse('https://www.youtube.com/watch?v=vfAXADfi5lw&list=PLflIpNYuu8Iso0J6i2H3nBBJlTkEQ6Fi1&index=136') !== 'vfAXADfi5lw') throw new AppException('test www.youtube.com (desktop website link) failed')
    if (YoutubeLinkParser.parse('https://youtu.be/vfAXADfi5lw') !== 'vfAXADfi5lw') throw new AppException('test youtu.be (short link) failed')
    if (YoutubeLinkParser.parse('https://www.youtube.com/embed/vfAXADfi5lw') !== 'vfAXADfi5lw') throw new AppException('test www.youtube.com/embed (embed link) failed')
    if (YoutubeLinkParser.parse('https://m.youtube.com/watch?v=3z7Fog6FvVI') !== '3z7Fog6FvVI') throw new AppException('test m.youtube.com (mobile link) failed')
    if (YoutubeLinkParser.parse('id123') !== 'id123') throw new AppException('test id failed')
    if (YoutubeLinkParser.parse('https://youtube.com/shorts/VWvyvTteoWo?feature=share') !== 'VWvyvTteoWo') throw new Error('test short link failed')
    if (YoutubeLinkParser.parse('https://www.youtube.com/shorts/VWvyvTteoWo?feature=share') !== 'VWvyvTteoWo') throw new Error('test short link failed')
    return 'test success'
  }
}
export default YoutubeLinkParser
